import { Box, useMediaQuery } from "@mui/material"
import { PageSection, ReferanceCard } from "../../components"
import { useTranslation } from "react-i18next"
import ImpactImage from '../../../../assets/images/svgs/impactOnPatients/impact_on_patients.png'
import VisualAcuity from "./VisualAcuity"
import TransMsg from './transMessage'
import { desktopEdHubReferences, mobileEdHubReferences } from "../../../../assets/data/educationHub/referancesData"
import { theme } from "../../../../utils/theme/godzilla_light"

const styles = {
    imageBoxSx: {
        py: "20px", px: "6px"
    }
}
const ImpactOnPatients = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(600))

    return (
        <Box>
            <VisualAcuity />
            <PageSection
                title={t(TransMsg.GA_CHANGES_TITLE)}
                description={t(TransMsg.GA_CHANGES_DESCRIPTION)}
                sectionTitle={t(TransMsg.GA_CHANGES_SUB_TITLE)}
                sectionImgUrl={ImpactImage}
                sectionCardSx={isMobileX ? { ...styles.imageBoxSx, backgroundColor: "transparent", boxShadow: "none" } : { backgroundColor: "transparent", boxShadow: "none" }}
                containerBoxSx={{ width: "100%", px: "31px" }} />
            <ReferanceCard
                referanceData={isMobileX ? mobileEdHubReferences : desktopEdHubReferences}
                wrapperSx={{ py: "27px" }}
            />
        </Box>
    )
}

export default ImpactOnPatients